import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import BreadcrumbMolecule from "../../molecules/BreadCrumb/BreadcrumbMolecule";
import CategoryListOrganism from "../../organisms/CategoryList/CategoryListOrganism";
import ProductGrid from "../../organisms/ProductGrid/ProductGrid";
import styles from "./modules/ProductListingPage.module.scss";
import { Helmet } from "react-helmet-async";

const ProductListingPage = () => {
  const { category: categoryFromURL, subcategory: subCategoryFromURL } =
    useParams();
  const [selectedCategory, setSelectedCategory] = useState(
    categoryFromURL || ""
  );
  const [selectedSubCategory, setSelectedSubCategory] = useState(
    subCategoryFromURL || ""
  );
  const [resultsCount, setResultsCount] = useState(0);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false); // Control drawer visibility for mobile
  const navigate = useNavigate();

  // Sync the selected category and subcategory from the URL
  useEffect(() => {
    setSelectedCategory(categoryFromURL || "");
    setSelectedSubCategory(subCategoryFromURL || "");
  }, [categoryFromURL, subCategoryFromURL]);

  // Handle category selection and update URL
  const handleCategoryChange = (category) => {
    if (category) {
      setSelectedCategory(category);
      setSelectedSubCategory(null);
      navigate(`/product-category/${category}`);
      setIsDrawerOpen(false); // Close the drawer on mobile when a selection is made
    }
  };

  // Handle subcategory selection and update URL
  const handleSubCategoryChange = (category, subCategory) => {
    if (category && subCategory) {
      setSelectedCategory(category);
      setSelectedSubCategory(subCategory);
      navigate(`/product-category/${category}/${subCategory}`);
      setIsDrawerOpen(false); // Close the drawer on mobile when a selection is made
    }
  };

  // Clears selected category and subcategory, then navigates to show all products
  const handleClearAll = () => {
    setSelectedCategory("");
    setSelectedSubCategory("");
    navigate("/product-category/"); // Adjust this path if your "all products" route is different
  };

  const title = categoryFromURL
    ? `${categoryFromURL} Products | NAM House of sleep`
    : `NAM House of sleep`;

  const description = categoryFromURL
    ? `Discover NAM House of sleep’s ${categoryFromURL}.`
    : `Discover NAM House of sleep’s products.`;

  return (
    <div className={styles.productListingPage}>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
      </Helmet>
      {/* Breadcrumb and Results Count */}
      <div className={styles.headerRow}>
        <BreadcrumbMolecule
          category={categoryFromURL}
          subCategory={subCategoryFromURL}
          resetSubCategory={() => setSelectedSubCategory(null)}
        />
        <div className={styles.resultsCount}>
          Showing all {resultsCount} results
        </div>
      </div>

      {/* Filter Button for Mobile */}
      <button
        className={styles.filterButton}
        onClick={() => setIsDrawerOpen(true)}
      >
        Filter
      </button>

      {/* Category Drawer for Mobile */}
      {isDrawerOpen && (
        <div className={styles.drawer}>
          <button
            className={styles.closeButton}
            onClick={() => setIsDrawerOpen(false)}
          >
            &times;
          </button>
          <CategoryListOrganism
            selectedCategory={selectedCategory}
            selectedSubCategory={selectedSubCategory}
            setCategory={handleCategoryChange}
            setSubCategory={handleSubCategoryChange}
          />
        </div>
      )}

      {/* Main Content */}
      <div className={styles.productListingPageContainer}>
        <div className={styles.leftSidebar}>
          <CategoryListOrganism
            selectedCategory={selectedCategory}
            selectedSubCategory={selectedSubCategory}
            setCategory={handleCategoryChange}
            setSubCategory={handleSubCategoryChange}
          />

          <button className={styles.clearAllButton} onClick={handleClearAll}>
            Clear All
          </button>
        </div>

        <div className={styles.rightSidebar}>
          <ProductGrid
            selectedCategory={selectedCategory}
            selectedSubCategory={selectedSubCategory}
            setResultsCount={setResultsCount}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductListingPage;
